import clsx from 'clsx';
import { FemaFloodZoneTooltip, FemaSpecialFloodAreaTooltipInfo } from './general/Tooltips';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

const FemaZoneWarning = ({ isFemaSpecialHazardArea, reportPage = false }) => {
  const floodZoneText = isFemaSpecialHazardArea
    ? 'Special Flood Hazard Area'
    : 'Not in Special Flood Hazard Area';
  const floodZoneTextClass = clsx(
    'px-2 pb-1 pt-2 font-bold',
    isFemaSpecialHazardArea ? 'bg-whoop-200 text-whoop' : 'bg-gray-100 text-rain'
  );

  const insuranceText = isFemaSpecialHazardArea ? 'Insurance Required' : 'Insurance Not Required';
  const insuranceTextClass = clsx(
    'px-2 pb-2 text-xs italic',
    isFemaSpecialHazardArea ? 'bg-whoop-200 font-bold' : 'bg-gray-100 font-light'
  );

  return (
    <div className="border border-fossil text-center text-sm">
      <div className="flex items-center justify-between border-b border-fossil bg-snow px-2 py-1 font-condensed text-base">
        {/* Empty div allows centering of text and right aligning of info */}
        {!reportPage && <div className="w-[16px] shrink-0" />}
        <div className="flex-1">FEMA Flood Zone</div>
        {!reportPage && (
          <>
            <button
              data-tooltip-id="fema-flood-zone"
              aria-label="fema-flood-zone-tooltip-tooltip"
              type="button"
            >
              <InformationCircleIcon className="h-5 text-primary" />
            </button>
            <FemaFloodZoneTooltip />
          </>
        )}
      </div>
      <div className={floodZoneTextClass}>
        <div className="flex items-center justify-between gap-2">
          {/* Empty div allows centering of text and right aligning of info */}
          {!reportPage && <div className="w-[16px] shrink-0" />}
          <div className="flex-1">{floodZoneText}</div>
          {!reportPage && <FemaSpecialFloodAreaTooltipInfo />}
        </div>
      </div>
      <div className={insuranceTextClass}>{insuranceText}</div>
    </div>
  );
};

export default FemaZoneWarning;
